var _defs, _path, _path2, _path3, _path4, _path5, _path6, _circle, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMedal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 160 160",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "gold",
    x1: 60,
    y1: 24,
    x2: 115,
    y2: 122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffdf59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffca2e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ribbon",
    x1: 54,
    y1: 113,
    x2: 71,
    y2: 146,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00579d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#0089d9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#25b3f2"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63 105 39 143 57 140 65 155 87 115Z",
    fill: "url(#ribbon)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m58 140 13-29 9 7-15 37Z",
    fill: "#0075c5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m96 115 19 40 10-15 16 3-22-40Z",
    fill: "#0086d6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m106 117 9 38 10-15-10-26Z",
    fill: "#005da8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m18 69 10 11M13 94h11",
    stroke: "#ffd030",
    strokeWidth: 7,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M90.00,19.00 L91.41,19.17 L92.80,19.65 L94.14,20.40 L95.43,21.36 L96.66,22.44 L97.83,23.54 L98.97,24.59 L100.10,25.49 L101.24,26.18 L102.42,26.64 L103.67,26.84 L105.01,26.80 L106.44,26.59 L107.94,26.25 L109.52,25.88 L111.12,25.56 L112.72,25.38 L114.26,25.40 L115.70,25.67 L117.00,26.23 L118.14,27.08 L119.10,28.19 L119.89,29.52 L120.52,30.99 L121.05,32.54 L121.51,34.09 L121.98,35.56 L122.50,36.90 L123.14,38.08 L123.94,39.06 L124.92,39.86 L126.10,40.50 L127.44,41.02 L128.91,41.49 L130.46,41.95 L132.01,42.48 L133.48,43.11 L134.81,43.90 L135.92,44.86 L136.77,46.00 L137.33,47.30 L137.60,48.74 L137.62,50.28 L137.44,51.88 L137.12,53.48 L136.75,55.06 L136.41,56.56 L136.20,57.99 L136.16,59.33 L136.36,60.58 L136.82,61.76 L137.51,62.90 L138.41,64.03 L139.46,65.17 L140.56,66.34 L141.64,67.57 L142.60,68.86 L143.35,70.20 L143.83,71.59 L144.00,73.00 L143.83,74.41 L143.35,75.80 L142.60,77.14 L141.64,78.43 L140.56,79.66 L139.46,80.83 L138.41,81.97 L137.51,83.10 L136.82,84.24 L136.36,85.42 L136.16,86.67 L136.20,88.01 L136.41,89.44 L136.75,90.94 L137.12,92.52 L137.44,94.12 L137.62,95.72 L137.60,97.26 L137.33,98.70 L136.77,100.00 L135.92,101.14 L134.81,102.10 L133.48,102.89 L132.01,103.52 L130.46,104.05 L128.91,104.51 L127.44,104.98 L126.10,105.50 L124.92,106.14 L123.94,106.94 L123.14,107.92 L122.50,109.10 L121.98,110.44 L121.51,111.91 L121.05,113.46 L120.52,115.01 L119.89,116.48 L119.10,117.81 L118.14,118.92 L117.00,119.77 L115.70,120.33 L114.26,120.60 L112.72,120.62 L111.12,120.44 L109.52,120.12 L107.94,119.75 L106.44,119.41 L105.01,119.20 L103.67,119.16 L102.42,119.36 L101.24,119.82 L100.10,120.51 L98.97,121.41 L97.83,122.46 L96.66,123.56 L95.43,124.64 L94.14,125.60 L92.80,126.35 L91.41,126.83 L90.00,127.00 L88.59,126.83 L87.20,126.35 L85.86,125.60 L84.57,124.64 L83.34,123.56 L82.17,122.46 L81.03,121.41 L79.90,120.51 L78.76,119.82 L77.58,119.36 L76.33,119.16 L74.99,119.20 L73.56,119.41 L72.06,119.75 L70.48,120.12 L68.88,120.44 L67.28,120.62 L65.74,120.60 L64.30,120.33 L63.00,119.77 L61.86,118.92 L60.90,117.81 L60.11,116.48 L59.48,115.01 L58.95,113.46 L58.49,111.91 L58.02,110.44 L57.50,109.10 L56.86,107.92 L56.06,106.94 L55.08,106.14 L53.90,105.50 L52.56,104.98 L51.09,104.51 L49.54,104.05 L47.99,103.52 L46.52,102.89 L45.19,102.10 L44.08,101.14 L43.23,100.00 L42.67,98.70 L42.40,97.26 L42.38,95.72 L42.56,94.12 L42.88,92.52 L43.25,90.94 L43.59,89.44 L43.80,88.01 L43.84,86.67 L43.64,85.42 L43.18,84.24 L42.49,83.10 L41.59,81.97 L40.54,80.83 L39.44,79.66 L38.36,78.43 L37.40,77.14 L36.65,75.80 L36.17,74.41 L36.00,73.00 L36.17,71.59 L36.65,70.20 L37.40,68.86 L38.36,67.57 L39.44,66.34 L40.54,65.17 L41.59,64.03 L42.49,62.90 L43.18,61.76 L43.64,60.58 L43.84,59.33 L43.80,57.99 L43.59,56.56 L43.25,55.06 L42.88,53.48 L42.56,51.88 L42.38,50.28 L42.40,48.74 L42.67,47.30 L43.23,46.00 L44.08,44.86 L45.19,43.90 L46.52,43.11 L47.99,42.48 L49.54,41.95 L51.09,41.49 L52.56,41.02 L53.90,40.50 L55.08,39.86 L56.06,39.06 L56.86,38.08 L57.50,36.90 L58.02,35.56 L58.49,34.09 L58.95,32.54 L59.48,30.99 L60.11,29.52 L60.90,28.19 L61.86,27.08 L63.00,26.23 L64.30,25.67 L65.74,25.40 L67.28,25.38 L68.88,25.56 L70.48,25.88 L72.06,26.25 L73.56,26.59 L74.99,26.80 L76.33,26.84 L77.58,26.64 L78.76,26.18 L79.90,25.49 L81.03,24.59 L82.17,23.54 L83.34,22.44 L84.57,21.36 L85.86,20.40 L87.20,19.65 L88.59,19.17 Z",
    fill: "url(#gold)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 90,
    cy: 73,
    r: 42,
    fill: "#ffda44",
    stroke: "#efb923",
    strokeWidth: 2.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M59 45a42 42 0 0 1 57-5",
    stroke: "#ffe986",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedal);
export default __webpack_public_path__ + "static/media/medal.7543ca93d5c98a2471090f3e2347efed.svg";
export { ForwardRef as ReactComponent };